<template>
  <BaseDialog
    :is-open="isOpen"
    type="basic"
    @close="emits('close')"
  >
    <div class="w-[500px] max-w-[70vw] mx-auto pt-4 md:pt-6">
      <div class="bg-surface-container-high rounded-large p-4 pb-2 w-full">
        <QRCode :link="url" />
        <span
          class="inline-block w-full text-[10px] text-center leading-none text-on-surface-variant/70 shrink wrap-anywhere mt-1"
        >
          {{ url }}
        </span>
        <div class="flex flex-row justify-end">
          <BaseButtonGroup class="mt-2" size="M">
            <BaseIconButton v-tooltip="$t('common.copy')" icon="content_copy" size="M" color="outlined" @click="copyToClipboard" />
            <BaseIconButton
            v-if="hasWebshare"
            v-tooltip="$t('common.share')"
            icon="share"
            size="M"
            color="outlined"
            @click="shareLink"
            />
            <BaseIconButton v-tooltip="$t('common.downloadQRCode')" icon="download" size="M" color="outlined" @click="download" />
          </BaseButtonGroup>
        </div>
      </div>
    </div>
    <template #dismiss
      ><BaseTextButton color="text" @click="emits('close')">{{
        $t('common.close')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script lang="ts" setup>
import QRCode from '@/core/components/qr-code/QRCode.vue'
import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
import { useShareLink } from '@/core/composables/use-share-link'
import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
import { useQRCode } from '@/core/composables/use-qr-code'
import BaseButtonGroup from '@/core/components/base/button/BaseButtonGroup.vue'
interface Props {
  isOpen: boolean
  url: string
}

const { url } = defineProps<Props>()

const { copyToClipboard, shareLink, hasWebshare } = useShareLink(url)
const { download } = useQRCode()

const emits = defineEmits<{
  (e: 'close'): void
  (e: 'deleteSurvey'): void
}>()
</script>
